define('vspot-angular/services/admin-service',[], function () {
    'use strict';

    return ['resources.Admin', function (Admin) {
        return {
            /*
             *  Get an email footer matching a particular type.
             *  @param {str} type  Which type of email footer to retrieve.
             */
            getEmailFooter: function (type) {
                return Admin.getEmailFooter({type:type});
            },
            
            /*
             *  Create an email footer on the server.
             *  @param {obj} data  Object with the fields for the server
             */
            addEmailFooter: function (data) {
                return Admin.addEmailFooter(data);
            },
            
            /*
             *  Retrieve the building block list
             */
            listBuildingBlocks: function () {
                return Admin.listBuildingBlocks();
            },
            
            /*
             *  Retrieve a single building block
             *  @param {int} id  ID of the building block to retrieve.
             */
            getBuildingBlock: function (id) {
                return Admin.getBuildingBlock({
                    id: id
                });
            },

            /*
             *  Create or update a building block. If id is included, it's update, if not, it's create.
             *  @param {obj} data  Object with the fields for the server
             */
            saveBuildingBlock: function (data) {
                return Admin.saveBuildingBlock(data);
            },

            /*
             *  Delete an existing building block
             *  @param {int} id  ID of the building block to delete.
             */
            deleteBuildingBlock: function (id) {
                return Admin.deleteBuildingBlock({
                    id: id
                });
            },

            /*
             *  Retrieve the list of widget types
             */
            widgetTypes: function () {
                return Admin.widgetTypes();
            },

            /*
             *  Retrieve the widget list
             *
             *  @param {bool} includePages  Should we include pages (big) in the return data?
             */
            listWidgets: function (includePages) {
                return Admin.listWidgets({
                    include_pages: includePages
                });
            },

            /*
             *  Create or update a widget. If id is included, it's update, if not, it's create.
             *  @param {obj} data  Object with the fields for the server
             */
            saveWidget: function (data) {
                return Admin.saveWidget(data);
            },

            /*
             *  Delete an existing widget
             *  @param {int} id  ID of the widget to delete.
             */
            deleteWidget: function (id) {
                return Admin.deleteWidget({
                    id: id
                });
            },

            /*
             *  Find a widget based on the title of the building block assigned to it.
             *  Sounds weird, but the use case is the "volunteerspot-default" building block can
             *  get assigned to any number of widgets. We want to find those widgets.
             *
             *  @param {str} title  Title of the building block to find
             */
            widgetsByBuildingBlock: function (title) {
                return Admin.widgetsByBuildingBlock({
                    title: title
                });
            },

            /*
             *  Retrieve the list of the sites we support
             */
            sitesList: function () {
                return Admin.sitesList();
            },

            /*
             *  Retrieve the list of banner images from Amazon S3
             *
             *  @param {bool} refresh  Should we invalidate the cache and get an updated copy?
             */
            bannerImageList: function (refresh) {
                return Admin.bannerImageList({
                    refresh: refresh
                });
            },

            /*
             *  Retrieve the list of article header images from Amazon S3
             *
             *  @param {bool} refresh  Should we invalidate the cache and get an updated copy?
             */
            articleHeadersList: function (refresh) {
                return Admin.articleHeadersList({
                    refresh: refresh
                });
            },

            /*
             *  Retrieve the list of resource types
             */
            resourceTypes: function () {
                return Admin.resourceTypes();
            },

            /*
             *  Retrieve the stuats of resources (report, list, thingy)
             */
            resourceStatus: function () {
                return Admin.resourceStatus();
            },

            /*
             *  Retrieve the list of resources.
             *  @param {str} type - Optional resource type to return (1colpage,
             *      2colpage, etc... see model page.rb for full list).
             */
            listResources: function (type) {
                var data = null;
                if( !global_helper.blank(type) ) {
                    data = {
                        'type': type
                    };
                }
                return Admin.listResources(data);
            },
            
            /*
             *  Retrieve a single resource
             *  @param {int} id  ID of the resource to retrieve.
             */
            getResource: function (id) {
                return Admin.getResource({
                    id: id
                });
            },

            /*
             *  Update a single component of a resource. Should be fast, for making
             *  lots of little updates, like reordering resources.
             *  @param {obj} data  Object with the fields for the server
             */
            saveResourceSimple: function (data) {
                return Admin.saveResourceSimple(data);
            },

            /*
             *  Create or update a resource. If id is included, it's update, if not, it's create.
             *  @param {obj} data  Object with the fields for the server
             */
            saveResource: function (data) {
                return Admin.saveResource(data);
            },

            /*
             *  Delete an existing resource
             *  @param {int} id  ID of the widget to delete.
             */
            deleteResource: function (id) {
                return Admin.deleteResource({
                    id: id
                });
            },
            
            /*
             *  Retrieve the subscriptions for a user.
             *  @param {int} id  Id of the user
             */
            wepaySubscriptions: function(id) {
                return Admin.wepaySubscriptions({
                    user_id: id
                });
            },
            
            /*
             *  Retrieve the subscription charges for a user.
             *  @param {int} id  Id of the user
             */
            wepaySubscriptionCharges: function(id) {
                return Admin.wepaySubscriptionCharges({
                    user_id: id
                });
            },
            
            /*
             *  Cancel a subscription for a user.
             *  @param {int} userId  Id of the user
             *  @param {int} subscriptionId  Id of the subscription
             */
            wepaySubscriptionCancel: function(userId, subscriptionId) {
                return Admin.wepaySubscriptionCancel({
                    user_id:            userId,
                    subscription_id:    subscriptionId
                });
            },
            
            /*
             *  Refund a payment to a user.
             *  @param {int} userId  Id of the user
             *  @param {int} subscriptionId  Id of the subscription
             */
            wepaySubscriptionChargeRefund: function(userId, subscriptionChargeId) {
                return Admin.wepaySubscriptionChargeRefund({
                    user_id:                userId,
                    subscription_charge_id: subscriptionChargeId
                });
            },
            
            /*
             *  Get a list of the ogrganizations.
             */
            showOrganizations: function() {
                return Admin.showOrganizations();
            },
            
            /*
             *  Add a user to an ogrganization.
             *  @param {int} userId  Id of the user
             *  @param {int} orgId  Id of the organization
             */
            addUserToOrganization: function(userId, orgId) {
                return Admin.addUserToOrganization({
                    user_id:            userId,
                    organization_id:    orgId
                });
            },
            
            /*
             *  List all ogrganizations for a specific user.
             *  @param {int} userId  Id of the user
             */
            listOrganizationsForUser: function(userId) {
                return Admin.listOrganizationsForUser({
                    user_id: userId
                });
            },
            
            /*
             *  List all users for an ogrganization.
             *  @param {int} orgId  Id of the organization
             */
            listUsersForOrganization: function(orgId) {
                return Admin.listUsersForOrganization({
                    org_id: orgId
                });
            },
            
            /*
             *  List all activities for an ogrganization.
             *  @param {int} orgId  Id of the organization
             */
            listActivitiesForOrganization: function(orgId) {
                return Admin.listActivitiesForOrganization({
                    org_id: orgId
                });
            },
            
            /*
             *  Delete a user from an ogrganization.
             *  @param {int} userId  Id of the user
             *  @param {int} orgId  Id of the organization
             */
            deleteUserFromOrganization: function(userId, orgId) {
                return Admin.deleteUserFromOrganization({
                    user_id:            userId,
                    organization_id:    orgId
                });
            },
            
            /*
             *  Make an ogrganization ad free.
             *  @param {int} orgId  Id of the organization
             */
            makeOrganizationAdFree: function(orgId) {
                return Admin.makeOrganizationAdFree({
                    organization_id: orgId
                });
            },
            
            /*
             *  Undo making an ogrganization ad free.
             *  @param {int} orgId  Id of the organization
             */
            makeOrganizationPay: function(orgId) {
                return Admin.makeOrganizationPay({
                    organization_id: orgId
                });
            },
            
            /*
             *  Check a short URL to see if it exists
             *  @param {str} token - the string to check if it's shortened.
             */
            checkShortUrl: function(token) {
                return Admin.checkShortUrl({
                    custom_url: token
                });
            },
            
            /*
             *  Make a short URL.
             *  @param {str} token - the string to use as the shortened URL.
             *  @param {str} url - the full URL to shorten
             */
            makeShortUrl: function(token, url) {
                return Admin.makeShortUrl({
                    custom_url: token,
                    url:        url
                });
            },
            
            /*
             *  Look up an email. Get back the user ID if it exists, status false if not.
             *  @param {str} email - The email to look up.
             */
            getUserIdByEmail: function(email) {
                return Admin.getUserIdByEmail({
                    email: email
                });
            },
            
            /*
             *  Look up a user by ID.
             *  @param {str} id - The id to look up.
             */
            inspectUserById: function(id) {
                return Admin.inspectUserById({
                    id: id
                });
            },
            
            /*
             *  Give a user the free campus plan
             *  @param {str} email - The email to look up.
             *  @param {str} orgDesc - The title or description for the organization.
             *  @param {int} schoolId - The id of the school to associate the organization with.
             */
            freeCampusPlan: function(email, orgDesc, schoolId) {
                return Admin.freeCampusPlan({
                    em_addr:            email,
                    org_description:    orgDesc,
                    school_id:          schoolId
                });
            },
            
            /*
             *  Look up all the activities a user has been invited to.
             *  @param {str} id - The id to look up.
             */
            invitationsByUserId: function(id) {
                return Admin.invitationsByUserId({
                    id: id
                });
            },
            
            /*
             *  Rebuild the nav tree.
             */
            rebuildNav: function() {
                return Admin.rebuildNav();
            },
            
            /*
             *  Stripe: list all Stripe plans
             */
            stripeListAllPlans: function() {
                return Admin.stripeListAllPlans();
            },
            
            /*
             *  Stripe: find a user's Stripe plan
             *
             * @param {int} userId - SignUp.com user ID.
             */
            stripeListUser: function(userId) {
                return Admin.stripeListUser({id: userId});
            },
            
            /*
             *  Stripe: cancel a user
             *
             * @param {int} stripeCustomerId - Stripe Customer ID. Get this from find_stripe_plan_for_user.
             * @param {int} stripeSubscriptionId - Stripe Subscription ID. Get this from find_stripe_plan_for_user.
             * @param {bool} immediately - Should the user be cancelled right now, or at the end of their pre-paid period (i.e. end of month or end of year)
             */
            stripeCancelUser: function(stripeCustomerId, stripeSubscriptionId, immediately) {
                return Admin.stripeCancelUser({
                    customer_id:        stripeCustomerId,
                    subscription_id:    stripeSubscriptionId,
                    now:                immediately
                });
            },
            
            /*
             *  Stripe: list changes for a user
             *
             * @param {int} stripeCustomerId - Stripe Customer ID. Get this from find_stripe_plan_for_user.
             */
            stripeListChargesForUser: function(stripeCustomerId) {
                return Admin.stripeListChargesForUser({
                    customer_id: stripeCustomerId
                });
            }
        };
    }];
});

